var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaybackRate = function SvgPlaybackRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    fill: "none",
    viewBox: "0 0 24 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 1.8a10.2 10.2 0 0 1 8.349 4.34l-5.78 3.337A3.602 3.602 0 0 0 8.882 13.8a3.6 3.6 0 0 0 6.587-2.764l7.373-4.256-.45-.78A12 12 0 0 0 12 0zm.9 11.76a1.8 1.8 0 1 1-1.8-3.118 1.8 1.8 0 0 1 1.8 3.117",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.2 12a10.2 10.2 0 0 1-2.988 7.212l1.273 1.273A12 12 0 0 0 24 12zM2.148 9.36a10.2 10.2 0 0 0 0 5.28l-1.74.466a12 12 0 0 1 0-6.212zM5.79 3.908a10.2 10.2 0 0 1 3.57-1.76L8.894.409A12 12 0 0 0 1.608 6l1.559.9A10.2 10.2 0 0 1 5.79 3.908M3.167 17.1a10.2 10.2 0 0 0 1.62 2.112l-1.272 1.273A12 12 0 0 1 1.608 18z"
  })));
};
export default SvgPlaybackRate;